import slice from 'store/features/projectData/slice'
import { withAppThunks } from 'store/with-app-thunks'
import { TAppDispatch, TGetState } from 'store/types'

const { actions } = slice

// Undo/Redo thunks
const undo = () =>
  withAppThunks(appThunks => (dispatch: TAppDispatch, getState: TGetState) => {
    const state = getState()
    const canUndo = state.projectData.past.length > 0

    if (canUndo) {
      dispatch(actions.undo())

      dispatch(appThunks.editorThunks.setActiveTimelineItems([]))
      dispatch(appThunks.editorThunks.setAsideOverlayContent(null))
      dispatch(appThunks.aiImageThunks.resetGenerateForm())
      dispatch(appThunks.aiVideoThunks.clearGenerationParams())
    }
  })

const redo = () =>
  withAppThunks(appThunks => (dispatch: TAppDispatch, getState: TGetState) => {
    const state = getState()
    const canRedo = state.projectData.future.length > 0

    if (canRedo) {
      dispatch(actions.redo())

      dispatch(appThunks.editorThunks.setActiveTimelineItems([]))
      dispatch(appThunks.editorThunks.setAsideOverlayContent(null))
    }
  })

export const projectDataHistoryThunks = {
  undo,
  redo
}
